import { Component, Input } from "@angular/core";
import { PopoverController } from "@ionic/angular";

@Component({
    selector: "time-picker-popover",
    templateUrl: "time-picker-popover.component.html",
    styleUrls: ["time-picker-popover.component.scss"],
})
export class TimePickerPopoverComponent {
    @Input() selectedTime: any;

    constructor(private popoverController: PopoverController) {
    }

    async closeTimePickerPopover() {
        const modal = await this.popoverController.getTop();
        await modal.dismiss("");
    }

    async validateTimePickerPopover() {
        const modal = await this.popoverController.getTop();
        await modal.dismiss({ time: (this.selectedTime) });
    }
}



